export const getQueryParams = (
  findParam: string,
  cb?: <T>(args: T) => void,
): string | null | void => {
  const param = new URLSearchParams(window.location.search).get(findParam);

  if (cb) {
    const cbResult = cb(param);
    return cbResult;
  }

  return param;
};
